import React from 'react';
import { Link } from 'react-router-dom';

// Componente do Footer
const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Coluna 1 - Sobre */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-lupa-orange">Lupa Data</h3>
            <p className="text-gray-400 mb-4">
              Especialistas em centralização de dados, big data e inteligência artificial, 
              ajudando empresas a transformar dados em resultados.
            </p>
            <div className="flex space-x-4">
              <Link to="https://linkedin.com/company/lupadata" className="text-gray-400 hover:text-lupa-orange">
                <span className="sr-only">LinkedIn</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </Link>
              <Link to="https://twitter.com/lupadata" className="text-gray-400 hover:text-lupa-orange">
                <span className="sr-only">Twitter</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                </svg>
              </Link>
              <Link to="https://instagram.com/lupadata" className="text-gray-400 hover:text-lupa-orange">
                <span className="sr-only">Instagram</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </Link>
            </div>
          </div>

          {/* Coluna 2 - Links Rápidos */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-lupa-orange">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-lupa-orange">Home</Link>
              </li>
              <li>
                <Link to="/servicos" className="text-gray-400 hover:text-lupa-orange">Serviços</Link>
              </li>
              <li>
                <Link to="/recursos" className="text-gray-400 hover:text-lupa-orange">Recursos</Link>
              </li>
              <li>
                <Link to="/sobre" className="text-gray-400 hover:text-lupa-orange">Sobre Nós</Link>
              </li>
              <li>
                <Link to="/contato" className="text-gray-400 hover:text-lupa-orange">Contato</Link>
              </li>
            </ul>
          </div>

          {/* Coluna 3 - Soluções */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-lupa-orange">Nossas Soluções</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/solucoes/lupa-paranoa" className="text-gray-400 hover:text-lupa-orange">Lupa Paranoá</Link>
              </li>
              <li>
                <Link to="/solucoes/lupa-cast" className="text-gray-400 hover:text-lupa-orange">Lupa Cast</Link>
              </li>
              <li>
                <Link to="/solucoes/lia" className="text-gray-400 hover:text-lupa-orange">LIA</Link>
              </li>
            </ul>
          </div>

          {/* Coluna 4 - Contato */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-lupa-orange">Contato</h3>
            <address className="not-italic text-gray-400">
              <p className="mb-2">QD SCN QD 01 BL F, EDF American Office Tower Sala 1608</p>
              <p className="mb-2">Asa Norte, Brasília - DF</p>
              <p className="mb-2">CEP: 70711-905</p>
              <p className="mb-2">
                <a href="mailto:contato@lupadata.com" className="hover:text-lupa-orange">comercial@lupadata.com</a>
              </p>
              <p>
                <a href="tel:+551112345678" className="hover:text-lupa-orange">+55 (61) 99119-8633</a>
              </p>
            </address>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              &copy; {new Date().getFullYear()} Lupa Data. Todos os direitos reservados.
            </p>
            <div className="mt-4 md:mt-0">
              <ul className="flex space-x-6">
                <li>
                  <Link to="/politica-de-privacidade" className="text-gray-400 hover:text-lupa-orange text-sm">
                    Política de Privacidade
                  </Link>
                </li>
                <li>
                  <Link to="/termos-de-uso" className="text-gray-400 hover:text-lupa-orange text-sm">
                    Termos de Uso
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
